export default __webpack_public_path__ + "static/media/grey-info.e76fdf7e.svg";